import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faClipboardList,
  faCheckCircle,
  faClock,
} from "@fortawesome/free-solid-svg-icons";
import todoList from "../assets/todo-list.png";
import goals from "../assets/Goals.png";
import screentime from "../assets/screentime.png";

export const FEATURES = [
  {
    title: "To Do List",
    icon: <FontAwesomeIcon icon={faClipboardList} color="white" size="lg" />,
    color: "blue",
    description:
      "Keep track of your tasks with a simple structured todo list. Organize by tags, set reminders, increase focus with an integrated timer, and so much more.",
    label: "STRUCTURE YOUR DAY",
    image: {
      src: todoList,
      alt: "To do list with time tracking",
    },
  },
  {
    title: "Goals Manager",
    color: "green",
    icon: <FontAwesomeIcon icon={faCheckCircle} color="white" size="lg" />,
    description:
      "Set OKR Goals to put your objectives into focus. Set targets and track, measure, and visualize your progress along the way.",
    label: "SET PERSONAL GOALS",
    image: {
      src: goals,
      alt: "Tools for planning and goal setting",
    },
  },
  {
    title: "Screen Time Tracker",
    color: "purple",
    icon: <FontAwesomeIcon icon={faClock} color="white" size="lg" />,
    description:
      "Track you screen time and have a healthier digital workflow. Set screen time goals and view your usage throughout the day and week.",
    label: "SET PERSONAL GOALS",
    image: {
      src: screentime,
      alt: "Productivity tracking software",
    },
  },
];
